import React, { Component } from 'react';
import { isFunction } from 'lodash/fp';

// local imports
import KPIChartActions from './Izenda.KPIChartActions';
import SimpleChart from './Izenda.SimpleChart';

class KPI extends Component {
    getChartOptions = () => {
        const { chartOptions: chartOpt } = this.props;
        let kpiActions = KPIChartActions(this.props);
        let chartSeries = kpiActions.getChartSeries();
        let chart = isFunction(chartSeries.charts[0]) ? chartSeries.charts[0]() : null;
        let chartOptions = $izenda.extend(true, {}, chartOpt, chart, {
          commonOptions: {
            izendaOptions: {
              autoResized: false
            }
          }
        });
        return chartOptions;
    }

    render() {
        const { seriesOptionsProps, chartOptions, finishedRender, ...chartProps } = this.props;

        try {
          return (
              <div className='izenda-ChartContainer izenda-Wrapper'>
                  <SimpleChart seriesOptions={seriesOptionsProps} chartOptions={this.getChartOptions()} finishedRender={finishedRender} {...chartProps}  />
              </div>
          );
        } catch (e) {
          if (typeof finishedRender === 'function') {
            finishedRender();
          }

          return (
            <div className='izenda-ChartContainer izenda-Wrapper'>
              {e.message}
            </div>
          );
        }
    }
}


export default KPI;


// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.KPI.js